const API_KEY =
  '43cb7f1a1d00ad8fc4366f71204115b8f72da289e3a175ef5ca3bcc92b482051';

export const ARBITRUM_RPC_URL = `https://rpc.ankr.com/arbitrum/${API_KEY}`;

export const ARBITRUM_SEPOLIA_TESTNET_RPC_URL = `https://rpc.ankr.com/arbitrum_sepolia/${API_KEY}`;

export const BSC_RPC_URL = `https://rpc.ankr.com/bsc/${API_KEY}`;

export const BSC_TESTNET_RPC_URL = `https://rpc.ankr.com/bsc_testnet_chapel/${API_KEY}`;

export const ETH_RPC_URL = `https://rpc.ankr.com/eth/${API_KEY}`;

export const ETH_HOLESKY_RPC_URL = `https://rpc.ankr.com/eth_holesky/${API_KEY}`;

export const FANTOM_RPC_URL = `https://rpc.ankr.com/fantom/${API_KEY}`;

export const FANTOM_TESTNET_RPC_URL = `https://rpc.ankr.com/fantom_testnet/${API_KEY}`;

export const OPTIMISIM_RPC_URL = `https://rpc.ankr.com/optimism/${API_KEY}`;

export const OPTIMISM_TESTNET_RPC_URL = `https://rpc.ankr.com/optimism_testnet/${API_KEY}`;

export const POLYGON_RPC_URL = `https://rpc.ankr.com/polygon/${API_KEY}`;

export const SCROLL_RPC_URL = `https://rpc.ankr.com/scroll/${API_KEY}`;

export const SCROLL_SEPOLIA_TESTNET_RPC_URL = `https://rpc.ankr.com/scroll_sepolia_testnet/${API_KEY}`;
